import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { QarepaApiLinks, QarepaDataSource } from '@qarepa/common';
import { EmployeeDisability } from '@qaroni-app/employee/types/employee-disability';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { PanelProfileService } from '../services/panel-profile.service';

export class EmployeeDisabilitiesDataSource extends QarepaDataSource<EmployeeDisability> {
  private employeeDisabilities$: Observable<EmployeeDisability[]> =
    this.panelProfileService.getEmployeeDisabilities$().pipe(shareReplay(1));

  public links$: Observable<QarepaApiLinks> = this.panelProfileService
    .getPaginationLinks$()
    .pipe(shareReplay(1));

  constructor(
    route: ActivatedRoute,
    router: Router,
    private panelProfileService: PanelProfileService,
    private employeeID: number
  ) {
    super(route, router);
  }

  connect(): Observable<EmployeeDisability[]> {
    super.initialization();

    return this.employeeDisabilities$;
  }

  public getQueryParamMap = (queryParamMap: ParamMap): void => {
    super.queryParamMapActions(queryParamMap);

    if (!Number.isInteger(this.employeeID)) {
      return;
    }

    this.panelProfileService.getEmployeeDisabilities(
      this.employeeID,
      this.queryParams
    );
  };
}
